module.exports = __webpack_public_path__ + "shishito.jpg?5969bbaa5438fa302c1daf7119951a41";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shishito.jpg
// module id = 7
// module chunks = 0